import { render, staticRenderFns } from "./FullDialogParte.vue?vue&type=template&id=7f0f5623&"
import script from "./FullDialogParte.vue?vue&type=script&lang=js&"
export * from "./FullDialogParte.vue?vue&type=script&lang=js&"
import style0 from "./FullDialogParte.vue?vue&type=style&index=0&id=7f0f5623&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports